import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { styled as muiStyled } from "@mui/material/styles";
import Icon from "assets/images/settings/billing2.svg";
import React, { useState } from "react";
import "react-calendar/dist/Calendar.css";
import styled from "styled-components";
import { TextView } from "../../components";
import { colors } from "../../utils";
import AddPayment from "./AddPayment";
import BillingDetails from "./BillingDetails";
import CustomTabs from "../CustomTabs";

const CenterWrapper = styled.div`
  background-color: ${colors.white};
  border-radius: 10px;
  margin: 0px 2vw;
  padding: 3vw;
`;
const HeaderIcon = styled.img`
  margin-right: 10px;
  width: 40px;
  height: 40px;
`;

const Content = styled.div`
  width: 90%;
  margin-top: 20px;
  position: relative;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const StyledTabs = muiStyled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{
      children: (
        <span className="MuiTabs-indicatorSpan" style={{ bottom: 45 }} />
      ),
    }}
  />
))({
  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
  },
  "& .MuiTabs-indicatorSpan": {
    width: "100%",
    backgroundColor: "#99439d",
  },
});

const StyledTab = muiStyled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    width: "50%",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    color: colors.black,
    "&.Mui-selected": {
      color: "#99439d",
      backgroundColor: "#fff9ff",
      fontWeight: 500,
    },
    "&.Mui-focusVisible": {
      backgroundColor: "rgba(100, 95, 228, 0.32)",
    },
  })
);

export default function Billing() {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <CenterWrapper>
      <CustomTabs value={value} onChange={handleChange} tabs={["Payment Method","Billing Information"]} />

      {value === 0 && (
        <Content>
          <Row>
            <HeaderIcon src={Icon} />
            <TextView variant="title">Add Payment Method</TextView>
          </Row>
          <AddPayment />
        </Content>
      )}
      {value === 1 && <BillingDetails />}
    </CenterWrapper>
  );
}
